export const analysisRules = [
  {
    id: 'word-icon-before-color',
    title: 'Значок важнее цвета',
    description:
      'При запуске анализа, если слово найдено в подкатегории с назначенным значком, значок показывается над словом. Если значка нет, слово окрашивается в цвет своей основной категории. Если слово не найдено в базе, оно остается черным.',
  },
  {
    id: 'save-analyzed-texts',
    title: 'Сохранение проанализированных текстов',
    description:
      'После запуска анализа под полем появляется кнопка сохранения текста. При сохранении текст получает номер от 001 до 999. Когда лимит 999 текстов достигнут, текущая серия архивируется в базе, а следующая серия снова начинается с номера 001.',
  },
  {
    id: 'verb-tense-icons',
    title: 'Указатели времени глагола',
    description:
      'Если слово найдено среди глаголов в базе, анализатор показывает над формой настоящего времени палец вниз, над формой прошедшего времени палец влево, а над будущими конструкциями skal/vil + инфинитив и kommer til å + инфинитив палец вперед.',
  },
];

export function getAnalyzerRule() {
  return analysisRules[0];
}
